// Pieces every Marketing page shares: the header with a visible Back, the
// four-page switcher, and the state / pillar chips.
import type { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import '../books/books.css';
import './marketing.css';
import { pillarLabel, type DisplayState } from '../../lib/marketing';

export const MK_PAGES = [
  { to: '/marketing', label: 'Overview' },
  { to: '/marketing/queue', label: 'Queue' },
  { to: '/marketing/inbox', label: 'Inbox' },
  { to: '/marketing/settings', label: 'Settings' },
] as const;

export function MkPage({ title, blurb, right, children, pendingReplies }: {
  title: string;
  blurb: ReactNode;
  right?: ReactNode;
  children: ReactNode;
  pendingReplies?: number;
}) {
  const nav = useNavigate();
  const isOverview = title === 'Overview';
  const back = isOverview ? { label: 'Backbar', to: '/' } : { label: 'Marketing', to: '/marketing' };
  return (
    <div className="books mk">
      <header className="bk-head">
        <div className="bk-head-left">
          <button type="button" className="bk-back" onClick={() => nav(back.to)}>
            <span aria-hidden="true">‹</span> {back.label}
          </button>
          <div className="bk-crumb">Marketing · Threads</div>
          <h1 className="bk-title">{title}</h1>
          <p className="bk-blurb">{blurb}</p>
        </div>
        {right && <div className="bk-head-right">{right}</div>}
      </header>
      <nav className="mk-tabs" aria-label="Marketing pages">
        {MK_PAGES.map((p) => (
          <NavLink key={p.to} to={p.to} end className={({ isActive }) => (isActive ? 'on' : '')}>
            {p.label}
            {p.label === 'Inbox' && pendingReplies ? <span className="mk-badge">{pendingReplies}</span> : null}
          </NavLink>
        ))}
      </nav>
      {children}
    </div>
  );
}

const STATE_WORDS: Record<DisplayState, string> = {
  draft: 'Draft', approved: 'Approved', rejected: 'Rejected', posted: 'Posted', failed: 'Failed',
};
export function StateChip({ state }: { state: DisplayState }) {
  return <span className={`mk-chip mk-chip--${state}`}>{STATE_WORDS[state]}</span>;
}
export function PillarChip({ pillar }: { pillar: string | null }) {
  return <span className="mk-chip mk-chip--pillar">{pillarLabel(pillar)}</span>;
}
